"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const ChartWrapper_1 = __importStar(require("../../components/ChartWrapper"));
const Tooltip_1 = __importDefault(require("../../components/Tooltip"));
const styles_module_css_1 = __importDefault(require("../../components/Tooltip/styles.module.css"));
const utilities_1 = require("../../utilities");
const date_1 = require("../../utilities/date");
const measurements_1 = require("../../utilities/measurements");
const types_1 = require("../../utilities/types");
const constants_1 = require("../BarChart/constants");
const model_1 = require("./model");
require("./styles.css");
const LINE_PADDING = 5;
const MIN_HEIGHT = 200;
const LABEL_FONT_SIZE = 13;
const LABEL_ROTATE_DEG = 45;
const DEFAULT_MARGINS = {
  top: 25,
  left: 0,
  right: 0,
  bottom: 0
};
const EducationBar = _ref => {
  let {
    barHeight = 40,
    breakdown,
    category: propCategory,
    data: rawData,
    date: propDate,
    groups,
    groupsLabel,
    groupsTitle,
    height,
    levelsLabelWidth,
    margins: rawMargins = DEFAULT_MARGINS,
    showDropdowns,
    showFooter = true,
    sortDropdowns,
    subtitle,
    subtitleFontSize,
    title,
    titleFontSize,
    tooltipDirection = 'below',
    tooltipStyle = {},
    width,
    categoryCallback = () => {},
    customTooltip = (values, category, color) => {
      const {
        formattedValue
      } = values.find(_ref2 => {
        let {
          name
        } = _ref2;
        return name === category;
      }) || {};
      return react_1.default.createElement("div", {
        className: styles_module_css_1.default['tooltip-grid']
      }, formattedValue && react_1.default.createElement("div", {
        className: styles_module_css_1.default['tooltip-row']
      }, react_1.default.createElement("div", {
        className: styles_module_css_1.default['tooltip-value'],
        style: {
          color
        }
      }, formattedValue)));
    },
    hoverCallback = () => {}
  } = _ref;
  if (height && height < MIN_HEIGHT) {
    console.warn(`Height cannot be lower than ${MIN_HEIGHT}.`);
  }
  const data = (0, utilities_1.extractDatasets)(rawData);
  const categories = (0, model_1.getCategories)(breakdown);
  const margins = {
    ...DEFAULT_MARGINS,
    ...rawMargins
  };
  const [category, setCategory] = (0, react_1.useState)(lodash_1.default.first(categories));
  const dropdownType = (0, utilities_1.getAxisTypeFromData)(data, 'x');
  const dropdownFormat = (0, react_1.useMemo)(() => (0, utilities_1.valueFormat)({
    params: {
      format: dropdownType || constants_1.DEFAULT_DROPDOWN_TYPE
    }
  }), [dropdownType]);
  const dataIdsString = (0, utilities_1.getDataIds)(data);
  const keys = (0, react_1.useMemo)(() => (0, utilities_1.extractKeys)(data, date_1.dateParser).map(i => ({
    ...i,
    parsed: dropdownFormat(i.key)
  })),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataIdsString, dropdownFormat]);
  const {
    key: date,
    setKey: setDate,
    dropdown
  } = (0, utilities_1.useDropdown)({
    enabled: true,
    keys,
    label: title ? ' ' : '',
    parser: dropdownFormat,
    sortBy: sortDropdowns,
    targetKey: null
  });
  const [prevPropDate, setPrevPropDate] = (0, react_1.useState)(undefined);
  const [prevPropCategory, setPrevPropCategory] = (0, react_1.useState)(undefined);
  const [tooltip, setTooltip] = (0, react_1.useState)({
    position: {
      x: null,
      y: null
    },
    node: null
  });
  if (propDate !== prevPropDate) {
    setDate(propDate);
    setPrevPropDate(propDate);
  }
  if (propCategory !== prevPropCategory) {
    setCategory(propCategory);
    setPrevPropCategory(propCategory);
  }
  const dropdowns = showDropdowns ? [dropdown, {
    options: categories,
    value: category,
    label: ' ',
    onChange: _ref3 => {
      let {
        target
      } = _ref3;
      setCategory(target.value);
      categoryCallback(target.value);
    }
  }] : [];
  return react_1.default.createElement(ChartWrapper_1.default, {
    className: "education-bars",
    title: title,
    subtitle: subtitle,
    titleFontSize: titleFontSize,
    subtitleFontSize: subtitleFontSize,
    dropdowns: dropdowns,
    showFooter: showFooter,
    width: width,
    height: height
  }, _ref4 => {
    let {
      chartWidth,
      chartHeight
    } = _ref4;
    const labels = breakdown.map(_ref5 => {
      let {
        label
      } = _ref5;
      return label;
    }).sort((a, b) => a.length > b.length ? -1 : 1);
    const labelDimensions = (0, measurements_1.textDimensions)({
      text: labels[0],
      fontSize: LABEL_FONT_SIZE,
      rotateDegrees: LABEL_ROTATE_DEG
    });
    const nodeHeight = !height ? barHeight : (chartHeight - margins.top - margins.bottom - model_1.GROUP_PADDING - model_1.BREAKDOWN_PADDING - labelDimensions.height) / 2;
    const svgHeight = margins.top + nodeHeight * 2 + model_1.GROUP_PADDING + model_1.BREAKDOWN_PADDING + labelDimensions.height;
    const minChartWrapperHeight = svgHeight + margins.bottom;
    const layouts = (0, model_1.getLayouts)(breakdown, groups, data, chartWidth, nodeHeight, category, date, levelsLabelWidth, margins);
    return react_1.default.createElement("div", {
      className: "chart-content",
      style: {
        height: chartHeight,
        minHeight: minChartWrapperHeight,
        position: 'relative',
        width: '100%'
      }
    }, react_1.default.createElement("svg", {
      width: chartWidth,
      height: svgHeight,
      style: {
        marginRight: margins.right,
        marginBottom: margins.bottom,
        marginLeft: margins.left
      }
    }, react_1.default.createElement(GroupsLayout, {
      groups: layouts.groups,
      tooltipDirection: tooltipDirection,
      tooltip: tooltip,
      setTooltip: setTooltip,
      hoverCallback: hoverCallback
    }), react_1.default.createElement(BreakdownsLayout, {
      breakdowns: layouts.breakdowns,
      tooltipDirection: tooltipDirection,
      tooltip: tooltip,
      setTooltip: setTooltip,
      hoverCallback: hoverCallback
    }), react_1.default.createElement("g", {
      className: "level-labels",
      transform: `translate(${margins.left},${margins.top})`
    }, react_1.default.createElement("line", {
      stroke: "black",
      x1: "0",
      x2: chartWidth
    }))), react_1.default.createElement(GroupLayoutLabels, {
      groups: layouts.groups
    }), react_1.default.createElement("div", {
      className: "groups-title",
      style: {
        position: 'absolute',
        bottom: `calc(100% - ${margins.top}px)`,
        width: levelsLabelWidth
      }
    }, groupsTitle), react_1.default.createElement("div", {
      className: "groups-label",
      style: {
        position: 'absolute',
        top: `${margins.top + LINE_PADDING}px`,
        width: levelsLabelWidth
      }
    }, groupsLabel), tooltip.position.x !== null && tooltip.position.y !== null && react_1.default.createElement(Tooltip_1.default, {
      direction: tooltipDirection,
      ...tooltip.position,
      style: tooltipStyle,
      width: chartWidth
    }, react_1.default.createElement("div", null, react_1.default.createElement("div", {
      className: styles_module_css_1.default['tooltip-title']
    }, groupsTitle), react_1.default.createElement("div", {
      className: styles_module_css_1.default['tooltip-subtitle']
    }, (0, model_1.getNodeSubtitle)(tooltip.node, groups, breakdown, category, groupsLabel)), react_1.default.createElement("div", {
      className: styles_module_css_1.default['tooltip-title']
    }, date), customTooltip((0, model_1.getNodeValues)(tooltip.node, breakdown, data, date, tooltip.type), category, tooltip.color, (0, model_1.getParentValues)(tooltip.node, breakdown, data, date)))));
  });
};
const GroupsLayout = _ref6 => {
  let {
    groups,
    tooltipDirection,
    setTooltip,
    hoverCallback
  } = _ref6;
  const groupsLayout = groups.map(_ref7 => {
    let {
      x,
      y,
      width,
      height,
      label,
      color
    } = _ref7;
    return {
      x,
      y,
      width,
      height,
      label,
      color
    };
  });
  return react_1.default.createElement(react_1.default.Fragment, null, groupsLayout.map((_ref8, i) => {
    let {
      x,
      y,
      width,
      height,
      color
    } = _ref8;
    return react_1.default.createElement("g", {
      key: groups[i].key
    }, react_1.default.createElement("rect", {
      x: x,
      y: y,
      width: width,
      height: height,
      fill: color,
      onMouseOver: () => {
        hoverCallback(groups[i].key);
        setTooltip({
          position: {
            x: x + width / 2,
            y: y + (tooltipDirection === 'below' ? height : 0)
          },
          node: groups[i].key,
          color: groups[i].color,
          type: 'group'
        });
      },
      onMouseOut: () => {
        hoverCallback(null);
        setTooltip({
          position: {
            x: null,
            y: null
          },
          node: null
        });
      }
    }));
  }));
};
const GroupLayoutLabels = _ref9 => {
  let {
    groups
  } = _ref9;
  const groupsLayout = groups.map(_ref10 => {
    let {
      x,
      y,
      width,
      height,
      label,
      color
    } = _ref10;
    return {
      x,
      y,
      width,
      height,
      label,
      color
    };
  });
  return react_1.default.createElement(react_1.default.Fragment, null, groupsLayout.map((_ref11, i) => {
    let {
      x,
      y,
      width,
      height,
      label
    } = _ref11;
    return react_1.default.createElement("div", {
      key: groups[i].key,
      style: {
        position: 'absolute',
        textAlign: 'center',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'none',
        justifyContent: 'center',
        height,
        width,
        top: y,
        left: x
      }
    }, react_1.default.createElement("div", null, label));
  }));
};
const BreakdownsLayout = _ref12 => {
  let {
    breakdowns,
    tooltipDirection,
    tooltip,
    hoverCallback,
    setTooltip
  } = _ref12;
  const breakdownsLayout = breakdowns.map(_ref13 => {
    let {
      x,
      y,
      width,
      height,
      label,
      color,
      key
    } = _ref13;
    return {
      x,
      y,
      width,
      height,
      label,
      color,
      key,
      textTransform: `translate(${x + width / 2},${y + height + 5}) rotate(-${LABEL_ROTATE_DEG})`
    };
  });
  return react_1.default.createElement(react_1.default.Fragment, null, breakdownsLayout.map((_ref14, i) => {
    let {
      x,
      y,
      width,
      height,
      label,
      color,
      textTransform
    } = _ref14;
    return react_1.default.createElement("g", {
      key: breakdowns[i].key
    }, react_1.default.createElement("rect", {
      x: x,
      y: y,
      width: width,
      height: height,
      fill: color,
      onMouseOver: () => {
        if (tooltip.node !== breakdowns[i].key) {
          hoverCallback(breakdowns[i].key);
        }
        setTooltip({
          position: {
            x: x + width / 2,
            y: y + (tooltipDirection === 'below' ? height : 0)
          },
          node: breakdowns[i].key,
          color: breakdowns[i].color,
          type: 'breakdown'
        });
      },
      onMouseOut: () => {
        hoverCallback(null);
        setTooltip({
          position: {
            x: null,
            y: null
          },
          node: null
        });
      }
    }), react_1.default.createElement("text", {
      style: {
        pointerEvents: 'none'
      },
      transform: textTransform,
      fill: "black",
      textAnchor: "end",
      dy: "0.35em"
    }, label));
  }));
};
const NodeShape = (0, prop_types_1.shape)({
  key: prop_types_1.string,
  color: prop_types_1.string,
  label: prop_types_1.string,
  value: prop_types_1.number,
  x: prop_types_1.number,
  y: prop_types_1.number,
  width: prop_types_1.number,
  height: prop_types_1.number
});
GroupsLayout.propTypes = {
  groups: (0, prop_types_1.arrayOf)(NodeShape).isRequired,
  tooltipDirection: prop_types_1.string,
  setTooltip: prop_types_1.func.isRequired,
  hoverCallback: prop_types_1.func.isRequired
};
GroupLayoutLabels.propTypes = {
  groups: (0, prop_types_1.arrayOf)(NodeShape).isRequired
};
BreakdownsLayout.propTypes = {
  breakdowns: (0, prop_types_1.arrayOf)(NodeShape).isRequired,
  tooltipDirection: prop_types_1.string,
  tooltip: (0, prop_types_1.shape)({
    position: (0, prop_types_1.shape)({
      x: prop_types_1.number,
      y: prop_types_1.number
    }),
    node: prop_types_1.string
  }),
  setTooltip: prop_types_1.func,
  hoverCallback: prop_types_1.func
};
EducationBar.propTypes = {
  ...ChartWrapper_1.chartWrapperPropTypes,
  /**
   * Height to draw the chart. Auto calculated if nto set
   */
  height: prop_types_1.number,
  /**
   * Width to draw the chart. This will set the width of the SVG.
   */
  width: prop_types_1.number.isRequired,
  /**
   * Height of the rects for the bars
   */
  barHeight: prop_types_1.number,
  /**
   * Width to use for the left labels of the chart.
   */
  levelsLabelWidth: prop_types_1.number,
  /**
   * Title that goes above the line
   */
  groupsTitle: prop_types_1.string,
  /**
   * label that goes below the line
   */
  groupsLabel: prop_types_1.string,
  /**
   * Defines the groups that the breakdowns belong to
   */
  groups: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    key: prop_types_1.string.isRequired,
    label: prop_types_1.string,
    color: prop_types_1.string
  })).isRequired,
  /**
   * Defines the breakdown for the bars
   */
  breakdown: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    group: prop_types_1.string.isRequired,
    key: prop_types_1.string.isRequired,
    label: prop_types_1.string,
    metrics: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
      name: prop_types_1.string.isRequired,
      id: prop_types_1.string.isRequired
    }))
  })).isRequired,
  /**
   * Data for the chart
   */
  data: (0, prop_types_1.oneOfType)([(0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)), (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    datasets: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)),
    sources: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.sourcesShape))
  }))]).isRequired,
  /**
   * Margins around the chart
   * Defaults to:
   *  top: 20
   *  bottom: 0
   *  left: 0
   *  right: 0
   */
  margins: (0, prop_types_1.shape)({
    top: prop_types_1.number,
    bottom: prop_types_1.number,
    left: prop_types_1.number,
    right: prop_types_1.number
  }),
  /**
   * False to hide the dropdowns
   */
  showDropdowns: prop_types_1.bool,
  /**
   * Sort dropdown values
   */
  sortDropdowns: (0, prop_types_1.oneOf)(['ascending', 'descending', true, false]),
  /**
   * Property to set the date from parent
   */
  date: prop_types_1.string,
  /**
   * Property to set the category from parent
   */
  category: prop_types_1.string,
  /**
   * Sets the shape of the tooltip
   */
  tooltipDirection: prop_types_1.string,
  /**
   * Returns custom content for the tooltip.
   *
   * @param {Array} values - values for each category with the selected date for the selected node
   * @param {string} category - the selected category
   * @param {string} color - the color of the selected node
   * @param {Array} parentValues - values for each category with the selected date for the parent of the selected node
   * @returns {ReactElement} - Element to render in the tooltip
   */
  customTooltip: prop_types_1.func,
  /**
   * Gets called when a node gets hovered.
   *
   * @param {string} nodeID - the ID of the hovered node
   */
  hoverCallback: prop_types_1.func,
  /**
   * Gets called when the category dropdown changes.
   *
   * @param {string} category - the selected category
   */
  categoryCallback: prop_types_1.func,
  /**
   * Gets called when the date dropdown changes.
   *
   * @param {string} date - the selected date formatted like in the dropdown
   */
  dateCallback: prop_types_1.func,
  tooltipStyle: react_style_proptype_1.default
};
exports.default = EducationBar;